import { Link } from 'react-router-dom'
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { useGpuClusterSummary } from '@/lib/gpus'
import { bytes } from '@/lib/format'

export function GpuClusterTile() {
  const { data, isLoading } = useGpuClusterSummary()

  if (isLoading) return <Skeleton className="h-32" />
  if (!data || data.total_gpus === 0) return null

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">
          <Link to="/nodes" className="hover:underline">GPUs</Link>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-semibold">
          {data.online_gpus}/{data.total_gpus}
        </div>
        <div className="text-xs text-muted-foreground">
          {data.active_gpus} active
          {data.avg_util_pct != null && (
            <> · {data.avg_util_pct.toFixed(0)}% avg util</>
          )}
        </div>
        <div className="text-xs text-muted-foreground">
          {bytes(data.total_mem_used)} / {bytes(data.total_mem_capacity)}
          {data.hottest_temp_c != null && <> · {data.hottest_temp_c.toFixed(0)}°C</>}
        </div>
      </CardContent>
    </Card>
  )
}
